import combineReducers from 'combine-reducers-global-state';
import { nameSpace } from '../Modules/nameSpace';

import {
  reducer as filterReducer,
  moduleName as filterModuleName,
} from '../Modules/filters';
import {
  reducer as dataGridTableReducer,
  moduleName as dataGridTableModuleName,
} from '../Modules/dataGridTable';

export const reducerKey = nameSpace;

const reducers = combineReducers({
  [filterModuleName]: filterReducer,
  [dataGridTableModuleName]: dataGridTableReducer,
});

export default reducers;
